module.exports = __webpack_public_path__ + "img/11.60095552.webp";